import React from "react";
import { Link, useLocation } from "react-router-dom";
import SoMLogo from "../images/SoM-logo.png"

const Footer = () => {
    const location = useLocation();

    const navLinks = [
        { path: "/", label: "Home" },
        { path: "/research", label: "Research" },
        { path: "/team", label: "Team" },
        { path: "/publications", label: "Publications" },
        { path: "/gallery", label: "Gallery" },
        { path: "/join-us", label: "Join Us" },
        { path: "/contact", label: "Contact" }
    ];

    return (
        <footer>
            <div className="footer-container">
                <div className="footer-section footer-info">
                    <h3 className="footer-lab-name">ROBINSON LAB</h3>
                    <p className="footer-division">Division of Immunology and Rheumatology</p>
                    <p className="footer-university">Stanford University</p>
                </div>
                
                <div className="footer-section footer-navigation">
                    <h4 className="footer-nav-title">Navigation</h4>
                    <nav className="footer-nav">
                        {navLinks.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={`footer-nav-link ${location.pathname === link.path ? 'active' : ''}`}
                            >
                                {link.label}
                            </Link>
                        ))}
                    </nav>
                </div>

                <div className="footer-section footer-logo">
                    <img src={SoMLogo} alt="Stanford School of Medicine Logo" className="som-logo" />
                </div>
            </div>
            <div className="footer-bottom">
                <p className="footer-copyright">© {new Date().getFullYear()} Robinson Lab. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
